import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'RadioGroup',
})(
  (
    { brandColors, spacing, breakpoints, type, typography: { pxToRem } },
    props
  ) => ({
    label: {
      ...type['16_medium'],
      color: darkOrLightStyle(props)(
        brandColors.tintsOffWhite40,
        brandColors.tintsNeutral20
      ),
    },
    fieldset: {
      border: 0,
      padding: 0,
      margin: 0,
      '&:has(input:disabled)': {
        opacity: 0.4,
        pointerEvents: 'none',
        cursor: 'default',
      },
    },
    fieldsetDisabled: {
      opacity: 0.4,
      pointerEvents: 'none',
      cursor: 'default',
    },
    legend: {
      color: darkOrLightStyle(props)(
        brandColors.tintsOffWhite40,
        brandColors.tintsNeutral20
      ),
      marginBottom: pxToRem(16),
      ...type['16_medium'],
      [breakpoints.up('sm')]: {
        ...type['18_medium'],
      },
      [breakpoints.up('lg')]: {
        ...type['20_medium'],
      },
    },
    legendSmall: {
      color: darkOrLightStyle(props)(
        brandColors.tintsOffWhite40,
        brandColors.tintsNeutral20
      ),
      marginBottom: pxToRem(16),
      ...type['14_medium'],
    },
    radio: {
      marginRight: spacing(1),
    },
    radioButtonsContainer: {
      display: 'flex',
      marginBottom: pxToRem(10),
    },
  })
);

export default useStyles;
